import { createContext } from "react";

export interface IAdminTourContext {
  currentStep: number;
  startTour: () => void;
  isRunning: boolean;
}

export const AdminTourContext = createContext<IAdminTourContext | null>(null);
